import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { closePricingModal } from '../../../../utils/close_modal';
import { HOST_URL } from '../../../../actions/api';
import { Nav, NavDropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '../../../CommonComponents/AssetsHelper';

export function AsideMenuHome(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isPlanExceeded = localStorage.getItem('plan_exceeded');
    const [support, setSupport] = useState(false);

    const location = useLocation();
    const { pathname } = location;
    const arry = pathname.split("/");
    const currentMenu = arry[arry.length - 1];

    const navigateHome = () =>{
        closePricingModal(dispatch);
         if(JSON.parse(localStorage.getItem('isCollaborator'))===0){
          navigate(`/walls/home`);
         }else{
            navigate(`/walls`)
         }
     }

    return <div className="aside-menu h-100">
        <div id="kt_aside_menu" className='overflow-y-auto overflow-x-hidden'>
            <Nav className="flex-column menu-nav py-3 px-0">
                {!(isPlanExceeded) && <Nav.Link className={`menu-item ${currentMenu === "home" ? "menu-item-active" : ""}`} onClick={() => !pathname.includes('extrawallfeeds') && navigateHome()} >
                    <FontAwesomeIcon type={'regular'} icon={'house'} iconClass={'me-2'} />
                    <span className="menu-text">Home</span>
                </Nav.Link>}
                <Nav.Link className={`menu-item ${currentMenu === "walls" ? "menu-item-active" : ""}`} onClick={()=>{ closePricingModal(dispatch); navigate(!pathname.includes('extrawallfeeds') ?props.user[`expire`]===1 ?`/walls/home`:`/walls`:'#')}}>
                    <FontAwesomeIcon type={'regular'} icon={'clone'} iconClass={'me-2'} />
                    <span className="menu-text">My Walls</span>
                </Nav.Link>
                {!((isPlanExceeded)) &&<Nav.Link className={`menu-item ${currentMenu === "transactions" ? "menu-item-active" : ""}`}  onClick={()=>{ closePricingModal(dispatch); navigate(!pathname.includes('extrawallfeeds') ?`/transactions`:`#`)}}>
                    <FontAwesomeIcon type={'regular'} icon={'circle-user'} iconClass={'me-2'} />
                    <span className="menu-text">Accounts</span>
                </Nav.Link> }

                <div className={`menu-item-submenu ${support ? "menu-item-open menu-item-active" : ""}`} onClick={()=>{setSupport(!support)}}>
                    <Nav.Link className={`menu-item menu-toggle ${currentMenu === "" ? "menu-item-active bg-light" : ""}`}>
                        <FontAwesomeIcon type={'regular'} icon={'gear'} iconClass={'me-2'} />
                        <span className="menu-text flex-grow-1">Support</span> 
                        <FontAwesomeIcon type={'regular'} icon={'angle-right'} iconClass={'menu-arrow'} />
                    </Nav.Link>
                    <div className="menu-submenu ps-5 content-none">
                        <Nav.Link className="p-0 pb-3 text-dark" onClick={window.Intercom ? (e) =>{window.Intercom('showNewMessage') }: ()=>{}}>
                            <FontAwesomeIcon type={'regular'} icon={'comment-dots'} iconClass={'me-2'} />
                            <span className="fw-medium">Chat</span>
                        </Nav.Link>
                        <Nav.Link className="p-0 pb-3 text-dark" href={`tel:+16289003005`} target="_blank">
                            <FontAwesomeIcon type={'regular'} icon={'phone-volume'} iconClass={'me-2'} />
                            <span className="fw-medium">Call</span>
                        </Nav.Link>
                        <Nav.Link id="initManageFeed" className="p-0 pb-3 text-dark" href='mailto:support@socialwalls.com'>
                            <FontAwesomeIcon type={'regular'} icon={'envelope'} iconClass={'me-2'} />
                            <span className="fw-medium">Email</span>
                        </Nav.Link>
                        <Nav.Link id="initManageFeed" className="p-0 pb-3 text-dark" href={`https://socialwalls.com/support/`} target="_blank">
                            <FontAwesomeIcon type={'regular'} icon={'book-open'} iconClass={'me-2'} />
                            <span className="fw-medium">Knowledge Base</span>
                        </Nav.Link>
                    </div>
                </div>
            </Nav>
        </div>
    </div>
}
